import { ROLE } from '../constants';

const { localStorage } = window;

const auth = {
  setLoginData(data) {
    const { login, isSuccess, accessToken } = data;
    localStorage.isSuccess = isSuccess;
    localStorage.role = login.roles;
    localStorage.login = JSON.stringify(login);
    localStorage.accessToken = accessToken;
  },

  setEmail(newEmail) {
    const loginData = localStorage.login ? JSON.parse(localStorage.login) : undefined;
    loginData.email = newEmail;
    localStorage.login = JSON.stringify(loginData);
  },

  getLoginData() {
    return localStorage.login ? JSON.parse(localStorage.login) : undefined;
  },

  isSuccess() {
    return localStorage.isSuccess === 'true';
  },

  isAdmin() {
    return localStorage?.role.includes(ROLE.ADMIN);
  },

  isPowerUser() {
    return localStorage?.role.includes(ROLE.POWER_USER);
  },


  isLightUser() {
    return localStorage?.role.includes(ROLE.LIGHT_USER);
  },

  getAccessToken() {
    return localStorage.accessToken;
  },

  logout() {
    localStorage.clear();
  },
};

export default auth;
